import Vue from 'vue';
import App from './App';
import store from './store';
import FastClick from 'fastclick';
// import { router } from './router/router';

// vue微信授权可使用下面的,或者剥离开来用transit.html
import { router } from './router/routerwechatAuth';
import wechatAuth from './utils/wechatAuth'
Vue.use(wechatAuth, {
  appid: "wxbad1a92a398c2ec3",
  scope: 'snsapi_userinfo',
}) 

import { RadioGroup,Overlay,Checkbox , Radio, Toast ,Dialog,Pagination, Empty,ImagePreview, Col, Row,Button,Loading,Icon,Swipe ,SwipeItem,Cell, CellGroup,Field,Popup,Uploader,Picker,Tab,Tabs,PullRefresh,Search,List,Rate,Collapse, CollapseItem,DatetimePicker} from 'vant';
Vue.use(Toast).use(RadioGroup).use(Checkbox).use(Overlay).use(Radio).use(Dialog).use(Pagination).use(Empty).use(ImagePreview).use(Col).use(Row).use(Button).use(Loading).use(Icon).use(Swipe).use(SwipeItem).use(Cell).use(CellGroup);
Vue.use(Uploader).use(Field).use(Popup).use(Picker).use(Tab).use(Tabs).use(PullRefresh).use(Search).use(List).use(Rate).use(Collapse).use(CollapseItem).use(DatetimePicker)
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.prototype.$getItem=function (name) {
	return window.sessionStorage.getItem(name);
}
import qs from "qs";
Vue.prototype.qs=qs;

import fuc from './utils/config.js'
Vue.prototype.fuc=fuc;
Vue.prototype.imgIp='';

// 解决点击延迟
if ('addEventListener' in document) {
	document.addEventListener('DOMContentLoaded', function() {
		FastClick.attach(document.body);
  }, false);
}


new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
